//store
import * as ProtocolStore from '../../../../redux/middleware/MedicalProtocolMiddleware';

// models
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';
import { ProtocolVisit } from '../../../../models/Entities/Protocols/ProtocolVisit';
import { ErrorType } from '../../../../models/HttpError';
import { AppState } from '../../../../redux/reducers';


interface IProps {
    ProtocolId: number;
    onSelectedVisit: (visit: ProtocolVisit[] | ProtocolVisit | undefined) => void;
    SelectedVisitIds: number[] | undefined;
    ExcludedVisitIds?: number[];
    MultiselectEnable: boolean;
    noteText?: string;
}

interface ConnectedProps {
    // loading protocol
    isLoadingProtocol: boolean;
    isProtocolLoadedSuccessfully: boolean;
    failOnLoadingProtocol: boolean;
    errorOnLoadProtocol: ErrorType | undefined;

    // loading visits
    isLoadingVisits: boolean;
    isVisitsLoadedSuccessfully: boolean;
    failOnLoadingVisits: boolean;
    errorOnLoadVisits: ErrorType | undefined;

    Protocol: Protocol | null;
    Visits: ProtocolVisit[];
}

interface DispatchProps {
    GetMedicalProtocolById: typeof ProtocolStore.actionCreators.GetMedicalProtocolById;
    GetVisitsByProtocolId: typeof ProtocolStore.actionCreators.GetVisitsByProtocolId;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const auxProtocol = state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) ?? null;
    
return {
    isLoadingProtocol: state.MedicalProtocols?.isLoadingOne,
    isProtocolLoadedSuccessfully: state.MedicalProtocols?.successLoadingOne,
    failOnLoadingProtocol: state.MedicalProtocols?.failOnLoadingOne,
    errorOnLoadProtocol: state.MedicalProtocols?.error,

    isLoadingVisits: auxProtocol?.isGettingVisits ?? false,
    isVisitsLoadedSuccessfully: auxProtocol?.gettingVisitsSuccess ?? false,
    failOnLoadingVisits: auxProtocol?.failOnGettingVisits ?? false,
    errorOnLoadVisits: auxProtocol?.ErrorOnGettingVisits,

    Protocol: auxProtocol,
    Visits: auxProtocol?.visits ?? []
}};

export const mapDispatchToProps = ({
  ...ProtocolStore.actionCreators
});


